(function () {
  window.__dfyCartVersion = '5.6';

  try {
    if (window.location.search.indexOf('dfydebug') > -1) {
      window.alert('DIFINEY JS v5.5 loaded \u2713');
    }
  } catch (e) { /* noop */ }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function titleCaseWord(word) {
    var keepUpper = {
      FDA: true,
      BPA: true,
      FAQ: true,
      FAQs: true,
      USA: true,
      US: true
    };
    var clean = word.replace(/[^A-Za-z]/g, '');
    if (keepUpper[clean]) return word;

    return word.replace(/[A-Za-z][A-Za-z'\u2019-]*/g, function (part) {
      if (keepUpper[part]) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
  }

  function normalizeUppercaseHeadings(root) {
    var selectors = [
      '.science__heading',
      '.nasal-steps__title',
      '.reviewed-by-pros__title',
      '.product-collection__heading',
      '.product-detail__heading',
      '.peace-of-mind__heading',
      '.customer-reviews__title',
      '.reviews-section__title',
      '.reviews-cta__heading',
      '.cta-section__heading',
      '.assessment-cta__heading',
      '.faq-section__heading',
      '.why-stands-out__title',
      '.final-cta__heading',
      '.reviews-real__heading',
      '.compat-quiz__title',
      '.compat-quiz__result-title',
      '.how-it-works__title h2'
    ].join(',');

    root.querySelectorAll(selectors).forEach(function (node) {
      var text = node.textContent || '';
      var letters = text.replace(/[^A-Za-z]/g, '');
      if (!letters || letters !== letters.toUpperCase()) return;

      node.textContent = text
        .split(/(\s+)/)
        .map(function (piece) {
          return /\S/.test(piece) ? titleCaseWord(piece) : piece;
        })
        .join('');
    });
  }

  function setupReveal() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section')).filter(function (section) {
      return !section.classList.contains('section-header') &&
        !section.classList.contains('announcement-bar-section') &&
        !section.classList.contains('shopify-section-group-header-group');
    });

    sections.forEach(function (section) {
      section.classList.add('difiney-in-view');
    });
  }

  function emphasizeReminder() {
    var nodes = document.querySelectorAll('.how-it-works__reminder-body, .how-it-works__reminder-title, .how-it-works__reminder-text');
    Array.prototype.forEach.call(nodes, function (el) {
      if (!el || el.querySelector('strong')) return;
      var text = el.textContent || '';
      var idx = text.indexOf('\u2014');
      if (idx === -1) idx = text.indexOf('--');
      if (idx < 1 || idx > 80) return;
      var head = text.slice(0, idx);
      var tail = text.slice(idx);
      el.textContent = '';
      var strong = document.createElement('strong');
      strong.textContent = head;
      el.appendChild(strong);
      el.appendChild(document.createTextNode(tail));
    });
  }

  var BUY_FORM_SELECTOR = '.hero-section__form, .how-it-works__form, .mobile-sticky-cta__form';
  var BUY_BUTTON_SELECTOR = '.hero-section__cta, .how-it-works__button, .mobile-sticky-cta__button, ' +
    '.hero-section__form [type="submit"], .how-it-works__form [type="submit"], ' +
    '.mobile-sticky-cta__form [type="submit"]';

  function setButtonState(button, text, disabled) {
    if (!button) return;
    var label = button.querySelector('span') || button;
    if (!button.dataset.dfyOriginalLabel) {
      button.dataset.dfyOriginalLabel = label.textContent.trim();
    }
    if (text === null) {
      label.textContent = button.dataset.dfyOriginalLabel;
    } else {
      label.textContent = text;
    }
    button.disabled = !!disabled;
  }

  function parseJsonResponse(response) {
    return response.text().then(function (raw) {
      var data = null;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        var isEdgeChallenge = response.headers.get('cf-mitigated') === 'challenge' ||
          /verifying your connection|cf-chl-|challenge-platform/i.test(raw);
        var err = new Error(isEdgeChallenge
          ? 'Shopify security verification interrupted the cart. Please refresh this page once, then try again.'
          : 'Non-JSON response (HTTP ' + response.status + ')');
        err.httpStatus = response.status;
        err.response = raw;
        err.isNonJsonResponse = true;
        err.isEdgeChallenge = isEdgeChallenge;
        throw err;
      }
      return { ok: response.ok, status: response.status, data: data };
    });
  }

  function getCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getCartSectionIds(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') {
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    return cart.getSectionsToRender().map(function (section) {
      return section.section || section.id;
    }).filter(Boolean);
  }

  function hasCompleteCartSections(cartData, sectionIds) {
    return !!(cartData && cartData.sections && sectionIds.every(function (sectionId) {
      return !!cartData.sections[sectionId];
    }));
  }

  function setFormError(form, message) {
    var productForm = form && form.closest ? form.closest('product-form') : null;
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(message || false);
      return;
    }

    var wrapper = form.querySelector('.product-form__error-message-wrapper, [data-cart-error], .dfy-cart-error-message');
    if (!wrapper && message) {
      wrapper = document.createElement('div');
      wrapper.className = 'dfy-cart-error-message';
      wrapper.setAttribute('role', 'alert');
      wrapper.setAttribute('aria-live', 'polite');
      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton && submitButton.parentNode) {
        submitButton.parentNode.insertBefore(wrapper, submitButton);
      } else {
        form.appendChild(wrapper);
      }
    }
    if (!wrapper) return;

    var messageNode = wrapper.querySelector('.product-form__error-message') || wrapper;
    messageNode.textContent = message || '';
    wrapper.toggleAttribute('hidden', !message);
  }

  function getCartErrorMessage(error) {
    if (error && error.itemWasAdded) {
      return error.message || 'Item added. Please open your cart to review it.';
    }
    if (error && error.cartOutcomeUnknown) {
      return "We couldn't confirm whether the item was added. Please check your cart before trying again.";
    }
    if (error && error.isEdgeChallenge) {
      return 'Shopify security verification interrupted the cart. Please refresh this page once, then try again.';
    }
    if (error && error.isNonJsonResponse) {
      return "We couldn't confirm the cart update. Please open your cart before trying again.";
    }
    var response = error && error.response;
    if (response) {
      if (typeof response.description === 'string' && response.description.trim()) return response.description.trim();
      if (typeof response.errors === 'string' && response.errors.trim()) return response.errors.trim();
      if (typeof response.message === 'string' && response.message.trim()) return response.message.trim();
    }
    if (error && (error.httpStatus === 429 || error.httpStatus === 430)) {
      return 'Too many requests. Please wait a moment and try again.';
    }
    return error && error.message ? error.message : 'Unable to add this item. Please try again.';
  }

  function addToCart(formData) {
    var leanData = new FormData();
    formData.forEach(function (value, key) {
      if (key !== 'sections' && key !== 'sections_url') leanData.append(key, value);
    });

    var cart = getCartComponent();
    var sectionIds = getCartSectionIds(cart);
    leanData.append('sections', sectionIds.join(','));
    leanData.append('sections_url', window.location.pathname);

    var cartAddUrl = window.routes && window.routes.cart_add_url
      ? window.routes.cart_add_url
      : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: leanData
    })
      .then(parseJsonResponse)
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status && result.data.status >= 400)) {
          var err = new Error((result.data && (result.data.description || result.data.message)) || ('HTTP ' + result.status));
          err.httpStatus = Number(result.data && result.data.status) || result.status;
          err.response = result.data;
          throw err;
        }
        return result.data;
      })
      .catch(function (error) {
        var status = error && error.httpStatus;
        // An add can succeed before its response is interrupted. Repeating
        // this non-idempotent POST could add the same item twice.
        if (error.isNonJsonResponse || !status || status >= 500) error.cartOutcomeUnknown = true;
        throw error;
      });
  }

  function refreshCartSections(cartData) {
    var cart = getCartComponent();
    var sectionIds = getCartSectionIds(cart);
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    var requestUrl = cartUrl + '?sections=' + encodeURIComponent(sectionIds.join(',')) +
      '&sections_url=' + encodeURIComponent(window.location.pathname) + '&_dfy=' + Date.now();

    return fetch(requestUrl, {
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-cache' }
    })
      .then(parseJsonResponse)
      .then(function (result) {
        if (!result.ok) throw new Error('Unable to refresh cart drawer');
        cartData.sections = result.data;
        return cartData;
      });
  }

  function addToCartReliably(formData) {
    return addToCart(formData).then(function (cartData) {
      var sectionIds = getCartSectionIds(getCartComponent());
      if (hasCompleteCartSections(cartData, sectionIds)) return cartData;
      return refreshCartSections(cartData).catch(function (drawerError) {
        console.warn('[DIFINEY cart] item added; drawer refresh failed:', drawerError);
        var error = new Error('Item added. Please open your cart to review it.');
        error.itemWasAdded = true;
        error.cause = drawerError;
        throw error;
      });
    });
  }

  function handleBuySubmit(form, buttonFromClick) {
    if (form.dataset.dfyCartBusy === 'true') return;
    if (window.__dfyCartAddPending) return;
    var button = buttonFromClick || form.querySelector('[type="submit"]');
    if (button && button.disabled) return;

    var formData = new FormData(form);
    formData.delete('return_to');
    if (!formData.get('quantity')) formData.set('quantity', '1');

    setFormError(form, false);
    form.dataset.dfyCartBusy = 'true';
    window.__dfyCartAddPending = true;
    setButtonState(button, 'Adding...', true);

    addToCartReliably(formData)
      .then(function (cartData) {
        var cart = getCartComponent();
        if (!cart || typeof cart.renderContents !== 'function' || !cartData.sections) {
          var missingCartError = new Error('Item added. Please open your cart to review it.');
          missingCartError.itemWasAdded = true;
          throw missingCartError;
        }

        try {
          cart.renderContents(cartData);
        } catch (renderError) {
          console.error('[DIFINEY cart] item added; validated drawer render failed:', renderError);
          var drawerRenderError = new Error('Item added. Please open your cart to review it.');
          drawerRenderError.itemWasAdded = true;
          drawerRenderError.cause = renderError;
          throw drawerRenderError;
        }

        setFormError(form, false);
        setButtonState(button, 'Added \u2713', true);
        window.__dfyCartAddPending = false;
        window.setTimeout(function () {
          setButtonState(button, null, false);
          delete form.dataset.dfyCartBusy;
        }, 1600);
      })
      .catch(function (error) {
        console.error('[DIFINEY cart v5.5] add to cart failed:', {
          message: error && error.message ? error.message : String(error),
          status: error && error.httpStatus,
          response: error && error.response,
          variantId: formData.get('id'),
          quantity: formData.get('quantity')
        });
        setFormError(form, getCartErrorMessage(error));
        setButtonState(button, null, false);
        window.__dfyCartAddPending = false;
        delete form.dataset.dfyCartBusy;
      });
  }

  function setupCartController() {
    if (document.documentElement.dataset.dfyCartControllerInitialized === 'true') return;
    document.documentElement.dataset.dfyCartControllerInitialized = 'true';

    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest ? event.target.closest(BUY_BUTTON_SELECTOR) : null;
      if (!trigger) return;
      var form = trigger.closest('form');
      if (!form || !form.querySelector('[name="id"]')) return;
      if (form.closest('product-form')) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      handleBuySubmit(form, trigger);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(BUY_FORM_SELECTOR)) return;
      if (form.closest('product-form')) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      handleBuySubmit(form, null);
    }, true);
  }

  var MOTION_TARGETS = [
    '.product-card',
    '.feature-item',
    '.stat-card',
    '.why-stands-out__card',
    '.reviewed-by-pros__card',
    '.customer-reviews__card',
    '.when-to-use__card',
    '.peace-of-mind__card',
    '.lifestyle-card',
    '.compat-quiz__card',
    '.see-it-in-action__heading',
    '.comparison-table__title',
    '.science__heading',
    '.nasal-steps__title',
    '.reviewed-by-pros__title',
    '.product-collection__heading',
    '.peace-of-mind__heading',
    '.customer-reviews__title',
    '.reviews-section__title',
    '.reviews-cta__heading',
    '.cta-section__heading',
    '.assessment-cta__heading',
    '.faq-section__heading',
    '.why-stands-out__title',
    '.final-cta__heading',
    '.reviews-real__heading',
    '.compat-quiz__title',
    '.comparison-table__grid--row',
    '.how-it-works__step',
    '.how-it-works__benefit',
    '.product-tabs__detail-card',
    '.product-tabs__qa-card',
    '.product-tabs__story-card',
    '.science__content-heading',
    '.science__content-body',
    '.peace-of-mind__item',
    '.hero-section__best-seller',
    '.hero-section__description',
    '.hero-section__price-row',
    '.hero-section__feature-item',
    '.hero-section__form'
  ].join(',');

  function setupTabMotionApi() {
    var api = window.DifineyMotion = window.DifineyMotion || {};
    if (api.swapPanels) return;

    function motionEnabled() {
      if (reduceMotion) return false;
      if (document.documentElement.classList.contains('shopify-design-mode')) return false;
      return !(window.Shopify && window.Shopify.designMode);
    }

    function measurePanel(panel, container) {
      if (!panel) return 0;
      if (!panel.hidden && panel.offsetHeight) return panel.offsetHeight;

      var wasHidden = panel.hidden;
      var previousStyle = panel.getAttribute('style');
      panel.hidden = false;
      panel.style.display = 'block';
      panel.style.position = 'absolute';
      panel.style.visibility = 'hidden';
      panel.style.pointerEvents = 'none';
      panel.style.width = container.clientWidth + 'px';
      var height = panel.offsetHeight;
      panel.hidden = wasHidden;
      if (previousStyle === null) {
        panel.removeAttribute('style');
      } else {
        panel.setAttribute('style', previousStyle);
      }
      return height;
    }

    api.swapPanels = function (container, currentPanel, nextPanel, commit, onStart) {
      if (!container || !currentPanel || !nextPanel || currentPanel === nextPanel) return false;
      if (container.dataset.dfyTabAnimating === 'true') return false;

      if (typeof onStart === 'function') onStart();
      if (!motionEnabled()) {
        commit();
        return true;
      }

      container.dataset.dfyTabAnimating = 'true';
      container.classList.add('dfy-tab-motion-ready');
      var currentPanelHeight = currentPanel.offsetHeight;
      var nextPanelHeight = measurePanel(nextPanel, container);
      var containerHeight = container.offsetHeight;
      var previousMinHeight = container.style.minHeight;
      container.style.minHeight = (containerHeight + Math.max(0, nextPanelHeight - currentPanelHeight)) + 'px';
      currentPanel.classList.add('dfy-tab-panel--leaving');

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        currentPanel.classList.remove('dfy-tab-panel--leaving');
        nextPanel.classList.remove('dfy-tab-panel--entering', 'dfy-tab-panel--entered');
        container.style.minHeight = previousMinHeight;
        delete container.dataset.dfyTabAnimating;
      }

      window.setTimeout(function () {
        try {
          commit();
          nextPanel.classList.add('dfy-tab-panel--entering');
          void nextPanel.offsetHeight;
          nextPanel.classList.add('dfy-tab-panel--entered');
          window.setTimeout(finish, 300);
        } catch (error) {
          finish();
          console.error('[DIFINEY motion] tab transition failed:', error);
        }
      }, 240);

      window.setTimeout(finish, 700);
      return true;
    };
  }

  function setupScrollMotion() {
    if (reduceMotion) return;
    if (!('IntersectionObserver' in window)) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var nodes = Array.prototype.slice.call(document.querySelectorAll(MOTION_TARGETS));
    if (!nodes.length) return;

    document.documentElement.classList.add('dfy-motion');

    var desktopMotion = window.matchMedia('(min-width: 990px)').matches;
    var delayStep = desktopMotion ? 55 : 45;
    var delayCap = desktopMotion ? 220 : 160;

    var lastSection = null;
    var index = 0;
    nodes.forEach(function (node) {
      var section = node.closest('.shopify-section');
      if (section !== lastSection) {
        lastSection = section;
        index = 0;
      }
      node.classList.add('dfy-reveal');
      node.style.setProperty('--dfy-delay', Math.min(index * delayStep, delayCap) + 'ms');
      index += 1;
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dfy-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: desktopMotion ? 0.14 : 0.1,
      rootMargin: desktopMotion ? '0px 0px -70px 0px' : '0px 0px -20px 0px'
    });

    nodes.forEach(function (node) {
      observer.observe(node);
    });

    setTimeout(function () {
      document.querySelectorAll('.dfy-reveal:not(.dfy-in)').forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          node.classList.add('dfy-in');
        }
      });
    }, 1500);

    setTimeout(function () {
      document.querySelectorAll('.dfy-reveal:not(.dfy-in)').forEach(function (node) {
        node.classList.add('dfy-in');
      });
    }, 8000);
  }

  function setupCartPopupCoordination() {
    if (document.documentElement.dataset.dfyCartPopupCoordination === 'true') return;
    if (!('MutationObserver' in window)) return;
    var modalSelector = '[aria-label="POPUP Form"], [data-kl-scroll-locking-modal="true"]';
    var closingPopups = new Map();
    var dismissTimer = null;

    function cartIsOpen() {
      // Drawer sections may be inserted or replaced after this script loads.
      // Always inspect the current connected component, never a captured node.
      return !!document.querySelector('cart-drawer.active');
    }

    function isExiting(style) {
      return /fade[-_]?out|exit/i.test(style.animationName || '') ||
        (/fade[-_]?in/i.test(style.animationName || '') && /reverse/.test(style.animationDirection || ''));
    }

    function isHidden(style) {
      return style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) <= 0.01;
    }

    function motionDuration(style) {
      function milliseconds(value) {
        return parseFloat(value) * (/ms$/.test(value.trim()) ? 1 : 1000) || 0;
      }
      function longest(durations, delays) {
        var delayList = (delays || '0s').split(',');
        return Math.max.apply(null, (durations || '0s').split(',').map(function (duration, index) {
          return milliseconds(duration) + milliseconds(delayList[index % delayList.length]);
        }));
      }
      return Math.max(longest(style.animationDuration, style.animationDelay), longest(style.transitionDuration, style.transitionDelay));
    }

    function releaseScrollLock(closedPopup) {
      var anotherModal = Array.prototype.some.call(document.querySelectorAll(modalSelector), function (modal) {
        if (closedPopup.contains(modal) || !modal.isConnected) return false;
        var style = window.getComputedStyle(modal);
        return style.display !== 'none' && style.visibility !== 'hidden' &&
          (!isExiting(style) || !isHidden(style));
      });
      if (!anotherModal) document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }

    function restoreInteraction(record) {
      if (!record.released) return;
      if (record.popup.style.getPropertyValue('pointer-events') === 'none' &&
          record.popup.style.getPropertyPriority('pointer-events') === 'important') {
        if (record.pointerEvents) record.popup.style.setProperty('pointer-events', record.pointerEvents, record.pointerPriority);
        else record.popup.style.removeProperty('pointer-events');
      }
      if (!record.wasInert) record.popup.removeAttribute('inert');
      record.released = false;
    }

    function forgetPopup(record) {
      window.clearTimeout(record.timer);
      record.observer.disconnect();
      record.popup.removeEventListener('animationend', record.onMotionEnd);
      record.popup.removeEventListener('transitionend', record.onMotionEnd);
      restoreInteraction(record);
      closingPopups.delete(record.popup);
    }

    function checkPopup(record) {
      var popup = record.popup;
      if (!popup.isConnected) {
        forgetPopup(record);
        releaseScrollLock(popup);
        return;
      }
      var style = window.getComputedStyle(popup);
      if (record.closed) {
        // Klaviyo can reuse the same node for a later opening. Undo only our
        // temporary interaction guard before letting that opening proceed.
        var opening = !isExiting(style) && /fade[-_]?in/i.test(style.animationName || '');
        if (style.display !== 'none' && style.visibility !== 'hidden' && (!isHidden(style) || opening)) {
          forgetPopup(record);
          scheduleDismiss();
        }
        return;
      }
      if (isExiting(style) && !record.exitStarted) {
        record.exitStarted = true;
        record.settleAt = Date.now() + motionDuration(style) + 80;
      }
      window.clearTimeout(record.timer);
      if (Date.now() < record.settleAt) {
        record.timer = window.setTimeout(function () { checkPopup(record); }, record.settleAt - Date.now());
        return;
      }
      if (!isHidden(style)) return;

      record.closed = true;
      // A completed forwards fade can leave a transparent, full-screen modal
      // in the DOM. Only a modal we asked to close gets this temporary guard.
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        record.pointerEvents = popup.style.getPropertyValue('pointer-events');
        record.pointerPriority = popup.style.getPropertyPriority('pointer-events');
        record.wasInert = popup.hasAttribute('inert');
        record.released = true;
        popup.style.setProperty('pointer-events', 'none', 'important');
        popup.setAttribute('inert', '');
      }
      releaseScrollLock(popup);
    }

    function dismissOfferPopup() {
      dismissTimer = null;
      closingPopups.forEach(checkPopup);
      if (!cartIsOpen()) return;

      document.querySelectorAll(modalSelector + ', [data-testid="POPUP"], .klaviyo-form, form[class*="klaviyo" i]').forEach(function (element) {
        var popup = element.closest(modalSelector);
        if (!popup || closingPopups.has(popup) || !/unlock\s*10%\s*off/i.test(popup.textContent || '')) return;
        var style = window.getComputedStyle(popup);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        var closeButton = popup.querySelector('button[aria-label*="close" i], [data-testid*="close" i], button[title*="close" i]');
        if (!closeButton) return;

        var record = { popup: popup, closed: false, released: false, exitStarted: false, settleAt: Date.now() + 500 };
        record.onMotionEnd = function (event) {
          if (event.target === popup) checkPopup(record);
        };
        record.observer = new MutationObserver(function () { checkPopup(record); });
        closingPopups.set(popup, record);
        record.observer.observe(popup, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
        popup.addEventListener('animationend', record.onMotionEnd);
        popup.addEventListener('transitionend', record.onMotionEnd);
        // Register before clicking: provider DOM mutations must not start a
        // second close or restart the exit animation.
        if (!isExiting(style)) closeButton.click();
        checkPopup(record);
      });
    }

    function scheduleDismiss() {
      if (dismissTimer === null) dismissTimer = window.setTimeout(dismissOfferPopup, 0);
    }

    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        if (mutation.type === 'childList') return true;
        var target = mutation.target;
        return target === document.body || target.matches('cart-drawer') ||
          target.closest(modalSelector);
      })) scheduleDismiss();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
    document.documentElement.dataset.dfyCartPopupCoordination = 'true';
    scheduleDismiss();
  }

  function init() {
    normalizeUppercaseHeadings(document);
    emphasizeReminder();
    setupReveal();
    setupTabMotionApi();
    setupScrollMotion();
    setupCartController();
    setupCartPopupCoordination();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
